import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class TagMenuDropdown extends ThemeComponent {
    @Ref() selectedTrigger!: HTMLButtonElement;
    @Ref() menuList!: HTMLUListElement;
    @Ref() container!: HTMLDivElement;

    init() {
        this.$listen(this.selectedTrigger, 'click', () => this.toggleMenu());
    }

    toggleMenu() {
        this.container.classList.toggle('is-active');
        document.body.classList.toggle('drawer-open');
        this.menuList.classList.toggle('is-active');
        this.selectedTrigger.classList.toggle('is-active');
    }
}
